import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import shortid from 'shortid'

import './style.scss'

const List = ({ id, contents, isOrdered, extraClasses }) => {
  const [fundListId, setFundListId] = useState()

  const createItems = () => contents.map((content, contentIndex) => <li key={`fil-list-${id}-item-${contentIndex}`}>{content}</li>)

  const getOrderedList = () => (
    <ol id={`fil-list-ordered-${fundListId}`} className={classnames('fil-list', extraClasses)}>
      {createItems()}
    </ol>
  )

  const getUnorderedList = () => (
    <ul id={`fil-list-unordered-${fundListId}`} className={classnames('fil-list', extraClasses)}>
      {createItems()}
    </ul>
  )

  useEffect(() => {
    const avaliableId = id || shortid.generate()
    setFundListId(avaliableId)
  }, [])
  return <React.Fragment>{isOrdered ? getOrderedList() : getUnorderedList()}</React.Fragment>
}

List.propTypes = {
  id: PropTypes.string,
  isOrdered: PropTypes.bool,
  contents: PropTypes.array.isRequired,
  extraClasses: PropTypes.string
}

List.defaultProps = {
  id: '',
  isOrdered: false,
  extraClasses: ''
}

export default List
